var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-layout",
        [
          !_vm.isTenant
            ? _c(
                "v-flex",
                { attrs: { md3: "", lg2: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      items: _vm.organizations,
                      "item-text": "organizationId",
                      "return-object": "",
                      label: _vm.$t("organizationId"),
                      clearable: "",
                      rules: [_vm.fieldIsRequired("Organization")]
                    },
                    model: {
                      value: _vm.organizationSelected,
                      callback: function($$v) {
                        _vm.organizationSelected = $$v
                      },
                      expression: "organizationSelected"
                    }
                  })
                ],
                1
              )
            : _c(
                "v-flex",
                { attrs: { md3: "", lg2: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      items: _vm.warehouses,
                      "item-text": "warehouseName",
                      "return-object": "",
                      label: _vm.$t("warehouse"),
                      clearable: "",
                      rules: [_vm.fieldIsRequired("Warehouse")]
                    },
                    model: {
                      value: _vm.warehouseSelected,
                      callback: function($$v) {
                        _vm.warehouseSelected = $$v
                      },
                      expression: "warehouseSelected"
                    }
                  })
                ],
                1
              ),
          _vm._v(" "),
          _c("v-flex", { attrs: { lg1: "" } }),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { md3: "", lg2: "", xl1: "" } },
            [
              _c(
                "v-menu",
                {
                  ref: "startPicker",
                  attrs: {
                    lazy: "",
                    "close-on-content-click": false,
                    transition: "scale-transition",
                    "offset-y": "",
                    "full-width": "",
                    "nudge-right": 40,
                    "min-width": "290px"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function(ref) {
                        var on = ref.on
                        return [
                          _c(
                            "v-text-field",
                            _vm._g(
                              {
                                attrs: {
                                  label: _vm.$t("startDate"),
                                  "prepend-icon": "event",
                                  readonly: ""
                                },
                                model: {
                                  value: _vm.startDateFormatted,
                                  callback: function($$v) {
                                    _vm.startDateFormatted = $$v
                                  },
                                  expression: "startDateFormatted"
                                }
                              },
                              on
                            )
                          )
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.startPicker,
                    callback: function($$v) {
                      _vm.startPicker = $$v
                    },
                    expression: "startPicker"
                  }
                },
                [
                  _vm._v(" "),
                  _c("v-date-picker", {
                    on: {
                      input: function($event) {
                        _vm.startPicker = false
                      }
                    },
                    model: {
                      value: _vm.startDate,
                      callback: function($$v) {
                        _vm.startDate = $$v
                      },
                      expression: "startDate"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { staticClass: "ml-5", attrs: { md3: "", lg2: "", xl1: "" } },
            [
              _c(
                "v-menu",
                {
                  ref: "endPicker",
                  attrs: {
                    lazy: "",
                    "close-on-content-click": false,
                    transition: "scale-transition",
                    "offset-y": "",
                    "full-width": "",
                    "nudge-right": 40,
                    "min-width": "290px"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function(ref) {
                        var on = ref.on
                        return [
                          _c(
                            "v-text-field",
                            _vm._g(
                              {
                                attrs: {
                                  label: _vm.$t("endDate"),
                                  "prepend-icon": "event",
                                  readonly: ""
                                },
                                model: {
                                  value: _vm.endDateFormatted,
                                  callback: function($$v) {
                                    _vm.endDateFormatted = $$v
                                  },
                                  expression: "endDateFormatted"
                                }
                              },
                              on
                            )
                          )
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.endPicker,
                    callback: function($$v) {
                      _vm.endPicker = $$v
                    },
                    expression: "endPicker"
                  }
                },
                [
                  _vm._v(" "),
                  _c("v-date-picker", {
                    on: {
                      input: function($event) {
                        _vm.endPicker = false
                      }
                    },
                    model: {
                      value: _vm.endDate,
                      callback: function($$v) {
                        _vm.endDate = $$v
                      },
                      expression: "endDate"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { staticClass: "ml-5" },
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", disabled: !_vm.isValid },
                  on: { click: _vm.requestReport }
                },
                [_vm._v(_vm._s(_vm.$t("export")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        [
          _c(
            "v-flex",
            [
              _c("v-data-table", {
                staticClass: "elevation-2 myDense",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.reports,
                  "item-key": "key",
                  pagination: _vm.pagination,
                  "rows-per-page-items": _vm.rowPerPage
                },
                on: {
                  "update:pagination": function($event) {
                    _vm.pagination = $event
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function(props) {
                      return [
                        _c("td", { staticClass: "subheading" }, [
                          _vm._v(_vm._s(props.index + 1))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "subheading" }, [
                          _vm._v(_vm._s(_vm.getEntityId(props.item)))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "subheading" }, [
                          _vm._v(_vm._s(_vm.toDateString(props.item.startDate)))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "subheading" }, [
                          _vm._v(_vm._s(_vm.toDateString(props.item.endDate)))
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-center" },
                          [
                            _c(
                              "v-layout",
                              [
                                _c(
                                  "v-flex",
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          color: "primary",
                                          flat: "",
                                          disabled: !props.item.zipFile
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.downloadReport(
                                              props.item
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              props.item.zipFile
                                                ? "download"
                                                : "preparing"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          dark: "",
                                          color: "secondary",
                                          flat: ""
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.deleteReport(props.item)
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.$t("delete")))]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-baf18f0e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-baf18f0e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PackageReportWarehouse.vue
// module id = null
// module chunks = 